export const confettiMove = () => {
  const Confettiful = function (el) {
    this.el = el;
    this.containerEl = null;

    this.confettiFrequency = 3;
    this.confettiColors = ["#99AC30", "#315E94", "#F838F8"];
    this.confettiAnimations = ["slow", "medium", "fast"];

    this._setupElements();
    this._renderConfetti();
  };

  Confettiful.prototype._setupElements = function () {
    this.containerEl = document.createElement("div");
    this.containerEl.className = "confetti-container";
    this.el.appendChild(this.containerEl);

    // ページの高さをカスタムプロパティとして設定
    document.documentElement.style.setProperty(
      "--page-height",
      `${document.body.scrollHeight + 200}px`
    );
  };

  Confettiful.prototype._renderConfetti = function () {
    this.confettiInterval = setInterval(() => {
      const confettiEl = document.createElement("div");
      const confettiSize = Math.floor(Math.random() * 3) + 14 + "px";
      const confettiBackground =
        this.confettiColors[
          Math.floor(Math.random() * this.confettiColors.length)
        ];
      const confettiLeft =
        Math.floor(Math.random() * this.el.offsetWidth) + "px";
      const confettiAnimation =
        this.confettiAnimations[
          Math.floor(Math.random() * this.confettiAnimations.length)
        ];

      confettiEl.classList.add(
        "confetti",
        "confetti--animation-" + confettiAnimation
      );
      confettiEl.style.left = confettiLeft;
      confettiEl.style.width = confettiSize;
      confettiEl.style.height = confettiSize;
      confettiEl.style.backgroundColor = confettiBackground;

      // アニメーション終了後に紙吹雪を削除
      confettiEl.removeTimeout = setTimeout(function () {
        confettiEl.parentNode.removeChild(confettiEl);
      }, 30000);

      this.containerEl.appendChild(confettiEl);
    }, 100);
  };

  window.confettiful = new Confettiful(document.querySelector(".js-confetti"));
};
